import moment from "moment";
import { createSelector } from "reselect";
import { isAllDay } from "~/components/Calendar/calendarUtils";

export const getAllCalendarEvents = (state) => state.calendarEvents;
export const getCalendarEventById = createSelector(
  getAllCalendarEvents,
  (state, id) => id,
  (calendarEvents, id) => calendarEvents[id]
);

export const getCalendarByEventId = createSelector(
  getCalendarEventById,
  (state) => state.calendars,
  (event, calendars) => {
    if (event && event.calendar_id) {
      return calendars[event.calendar_id];
    }
  }
);

export const getExcludedDatesByEventId = createSelector(getCalendarEventById, getAllCalendarEvents, (event, events) => {
  if (event) {
    const recurrenceInstances = Object.values(events)
      .filter((e) => e.uid === event.uid && e.recurrence_instance !== null)
      .map((e) =>
        isAllDay(event)
          ? moment(e.recurrence_instance).toDate()
          : moment.utc(e.recurrence_instance).tz(moment.defaultZone.name).toDate()
      );
    return recurrenceInstances;
  }
  return [];
});
